"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.colors = void 0;
var colors = {
  blue: '#007bff',
  // primary
  blueHoverFocusA: '#0056b3',
  blueHoverFocus: '#0062cc',
  blueBoxShadow: 'rgba(0, 123, 255, 0.5)',
  blueAlertText: '#004085',
  blueAlertBackground: '#cce5ff',
  blueAlertBorder: '#b8daff',
  blueAlertBorderTop: '#9fcdff',
  blueAlertAHoverFocus: '#002752',
  inigo: '#6610f2',
  purple: '#6f42c1',
  pink: '#e83e8c',
  red: '#dc3545',
  // danger
  redHoverFocus: '#bd2130',
  redBoxShadow: 'rgba(220, 53, 69, 0.5)',
  redAlertText: '#721c24',
  redAlertBackground: '#f8d7da',
  redAlertBorder: '#f5c6cb',
  redAlertBorderTop: '#f1b0b7',
  redAlertAHoverFocus: '#491217',
  orange: '#fd7e14',
  yellow: '#ffc107',
  // warning
  yellowHoverFocus: '#d39e00',
  yellowBoxShadow: 'rgba(255, 193, 7, 0.5)',
  yellowAlertText: '#856404',
  yellowAlertBackground: '#fff3cd',
  yellowAlertBorder: '#ffeeba',
  yellowAlertBorderTop: '#ffe8a1',
  yellowAlertAHoverFocus: '#533f03',
  green: '#28a745',
  // success
  greenHoverFocus: '#1e7e34',
  greenBoxShadow: 'rgba(40, 167, 69, 0.5)',
  greenAlertText: '#155724',
  greenAlertBackground: '#d4edda',
  greenAlertBorder: '#c3e6cb',
  greenAlertBorderTop: '#b1dfbb',
  greenAlertAHoverFocus: '#0b2e13',
  teal: '#20c997',
  cyan: '#17a2b8',
  // info
  cyanHoverFocus: '#117a8b',
  cyanBoxShadow: 'rgba(23, 162, 184, 0.5)',
  cyanAlertText: '#0c5460',
  cyanAlertBackground: '#d1ecf1',
  cyanAlertBorder: '#bee5eb',
  cyanAlertBorderTop: '#abdde5',
  cyanAlertAHoverFocus: '#062c33',
  white: '#fff',
  gray: '#6c757d',
  // secondary
  grayHoverFocus: '#545b62',
  grayBoxShadow: 'rgba(108, 117, 125, 0.5)',
  grayAlertText: '#383d41',
  grayAlertBackground: '#e2e3e5',
  grayAlertBorder: '#d6d8db',
  grayAlertBorderTop: '#c8cbcf',
  grayAlertAHoverFocus: '#202326',
  gray100: '#f8f9fa',
  // light
  gray100HoverFocus: '#dae0e5',
  gray100BoxShadow: 'rgba(248, 249, 250, 0.5)',
  gray100AlertText: '#818182',
  gray100AlertBackground: '#fefefe',
  gray100AlertBorder: '#fdfdfe',
  gray100AlertBorderTop: '#ececf6',
  gray100AlertAHoverFocus: '#686868',
  gray200: '#e9ecef',
  gray300: '#dee2e6',
  gray400: '#ced4da',
  gray500: '#adb5bd',
  gray600: '#868e96',
  gray700: '#495057',
  gray800: '#343a40',
  // dark
  gray800HoverFocus: '#1d2124',
  gray800BoxShadow: 'rgba(52, 58, 64, 0.5)',
  gray800AlertText: '#1b1e21',
  gray800AlertBackground: '#d6d8d9',
  gray800AlertBorder: '#c6c8ca',
  gray800AlertBorderTop: '#b9bbbe',
  gray800AlertAHoverFocus: '#040505',
  gray900: '#212529',
  // darker
  gray900HoverFocus: '#16181b',
  gray900BoxShadow: 'rgba(0, 0, 0, 0.15)',
  black: '#000',
  buttonPrimaryBackgroundColor: '#007bff',
  buttonPrimaryActiveBorderColor: '#005cbf',
  buttonPrimaryHoverFocusBackgroundColor: '#0069d9',
  buttonSecondaryBackgroundColor: '#6c757d',
  buttonSecondaryActiveBorderColor: '#4e555b',
  buttonSecondaryHoverFocusBackgroundColor: '#5a6268',
  buttonSuccessBackgroundColor: '#28a745',
  buttonSuccessActiveBorderColor: '#1c7430',
  buttonSuccessHoverFocusBackgroundColor: '#218838',
  buttonDangerBackgroundColor: '#dc3545',
  buttonDangerActiveBorderColor: '#b21f2d',
  buttonDangerHoverFocusBackgroundColor: '#c82333',
  buttonWarningBackgroundColor: '#ffc107',
  buttonWarningActiveBorderColor: '#c69500',
  buttonWarningHoverFocusBackgroundColor: '#e0a800',
  buttonInfoBackgroundColor: '#17a2b8',
  buttonInfoActiveBorderColor: '#10707f',
  buttonInfoHoverFocusBackgroundColor: '#138496',
  buttonLightBackgroundColor: '#f8f9fa',
  buttonLightActiveBorderColor: '#d3d9df',
  buttonLightHoverFocusBackgroundColor: '#e2e6ea',
  buttonDarkBackgroundColor: '#343a40',
  buttonDarkActiveBorderColor: '#171a1d',
  buttonDarkHoverFocusBackgroundColor: '#23272b',
  backgroundMark: '#fcf8e3',
  borderCard: 'rgba(0, 0, 0, 0.125)',
  backgroundCard: '#fff',
  backgroundCardFooter: 'rgba(0, 0, 0, 0.03)',
  formControlBorderFocus: '#80bdff',
  formControlBoxShadowFocus: 'rgba(0, 123, 255, 0.25)',
  formControlBoxShadowValid: 'rgba(40, 167, 69, 0.25)',
  formControlBoxShadowInvalid: 'rgba(220, 53, 69, 0.25)',
  listItemDefaultHover: 'rgb(248, 249, 250)',
  modalBorder: 'rgba(0, 0, 0, 0.2)',
  navbarLightColor: 'rgba(0, 0, 0, 0.5)',
  navbarLightColorHoverFocus: 'rgba(0, 0, 0, 0.7)',
  navbarLightColorActive: 'rgba(0, 0, 0, 0.9)',
  navbarLightColorDisabled: 'rgba(0, 0, 0, 0.3)',
  navbarLightBorderColor: 'rgba(0, 0, 0, 0.1)',
  popoverArrowBorderColor: 'rgba(0, 0, 0, 0.25)',
  navbarDarkColor: 'rgba(255, 255, 255, 0.5)',
  navbarDarkColorHoverFocus: 'rgba(255, 255, 255, 0.75)',
  navbarDarkColorDisabled: 'rgba(255, 255, 255, 0.25)',
  navbarDarkColorActive: 'rgba(255, 255, 255, 0.9)',
  navbarDarkBorderColor: 'rgba(255, 255, 255, 0.1)',
  popoverHeaderBackgroundColor: '#f7f7f7',
  popoverHeaderBorderColor: '#ebebeb',
  tableStripedBackgroundColor: 'rgba(0, 0, 0, 0.05)',
  tableBackgroundColorHoverFocus: 'rgba(0, 0, 0, 0.075)',
  tableDarkBorderColor: '#32383e',
  tableDarkStripedBackgroundColor: 'rgba(255, 255, 255, 0.05)',
  tableDarkStripedBackgroundColorHoverFocus: 'rgba(255, 255, 255, 0.075)'
};
exports.colors = colors;